<template>
  <el-dialog :visible="visible" @update:visible="$emit('update:visible', $event)" width="560px" append-to-body custom-class="add-member-dialog" :show-close="false">
    <div class="dlg-header">
      <h3 class="dlg-title">分配数据权限</h3>
      <i class="el-icon-close dlg-close" @click="close"></i>
    </div>

    <div class="dlg-body">
      <div v-if="user" class="dlg-section" style="margin-bottom:8px">
        <span style="color:#64748b;font-size:14px">用户：</span>
        <strong style="color:#0f172a">{{ user.name || user.username }}</strong>
      </div>

      <!-- 已有权限 -->
      <div v-if="existingList.length > 0" class="dlg-section">
        <label class="dlg-label" style="font-size:13px;color:#94a3b8">已有权限</label>
        <el-tag v-for="p in existingList" :key="p.id || (p.dataType + '-' + p.mixedId)" closable @close="removeOnePerm(p)" style="margin:0 6px 6px 0" size="medium">
          {{ p.dataTypeName || p.DataTypeName }}：{{ p.mixedName || p.MixedName }}
        </el-tag>
      </div>

      <!-- 新增权限 -->
      <div class="dlg-section">
        <label class="dlg-label">权限级别</label>
        <div class="role-pills">
          <span class="role-pill" :class="{ active: form.dataType === 1 }" @click="onTypeChange(1)" v-if="userRole !== 'agent'">全国</span>
          <span class="role-pill" :class="{ active: form.dataType === 2 }" @click="onTypeChange(2)" v-if="userRole !== 'agent'">大区</span>
          <span class="role-pill" :class="{ active: form.dataType === 3 }" @click="onTypeChange(3)" v-if="userRole !== 'agent'">小区</span>
          <span class="role-pill" :class="{ active: form.dataType === 4 }" @click="onTypeChange(4)">经销商</span>
        </div>
      </div>

      <div class="dlg-section" v-if="form.dataType === 2 || form.dataType === 3">
        <label class="dlg-label">选择大区</label>
        <el-select v-model="form.daquId" placeholder="选择大区" style="width:100%" class="dlg-select" @change="onDaquChange" filterable>
          <el-option v-for="d in daquList" :key="d.Id || d.id" :label="d.Daqu_name || d.daqu_name || d.name" :value="d.Id || d.id" />
        </el-select>
      </div>

      <div class="dlg-section" v-if="form.dataType === 3">
        <label class="dlg-label">选择小区</label>
        <el-select v-model="form.xiaoquId" placeholder="选择小区" style="width:100%" class="dlg-select" filterable>
          <el-option v-for="x in xiaoquList" :key="x.Id || x.id" :label="x.Xiaoqu_name || x.xiaoqu_name || x.name" :value="x.Id || x.id" />
        </el-select>
      </div>

      <div class="dlg-section" v-if="form.dataType === 4">
        <label class="dlg-label">搜索经销商</label>
        <el-select v-model="form.dealerId" placeholder="输入编码或名称搜索" style="width:100%" class="dlg-select" filterable remote :remote-method="searchDealers" multiple :loading="dealerLoading">
          <el-option v-for="d in dealerList" :key="d.id" :label="d.code ? `${d.code} - ${d.name}` : d.name" :value="d.id" />
        </el-select>
      </div>
    </div>

    <div class="dlg-footer">
      <el-button @click="close" class="dlg-cancel-btn">取消</el-button>
      <el-button type="primary" @click="doSave" :loading="saving" class="dlg-confirm-btn">保存权限</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getPermissions, savePermissions, deletePermission } from '@/app/index/api/project/permission'

export default {
  name: 'PermissionDialog',
  props: {
    visible: { type: Boolean, default: false },
    user: { type: Object, default: null },
    userRole: { type: String, default: '' },
    projectId: { type: [String, Number], required: true }
  },
  data() {
    return {
      existingList: [],
      saving: false,
      form: { dataType: 2, daquId: null, xiaoquId: null, dealerId: [] },
      daquList: [],
      xiaoquList: [],
      dealerList: [],
      dealerLoading: false
    }
  },
  watch: {
    visible(val) {
      if (val && this.user) this.loadData()
    }
  },
  methods: {
    close() { this.$emit('update:visible', false) },
    async loadData() {
      this.form = { dataType: this.userRole === 'agent' ? 4 : 2, daquId: null, xiaoquId: null, dealerId: [] }
      this.existingList = []
      try {
        const res = await getPermissions({ uid: this.user.uid || this.user.userId, projectId: parseInt(this.projectId) })
        const d = res?.data?.data
        this.existingList = Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : [])
      } catch (e) { console.error('加载权限失败', e) }
      await this.loadDaqu()
    },
    async loadDaqu() {
      try {
        const { data } = await this.axios.get('/Region/daqu/list', { projectId: this.projectId })
        this.daquList = data.data?.data || data.data || data || []
      } catch (e) { console.error('加载大区失败', e) }
    },
    async loadXiaoqu(daquId) {
      try {
        const { data } = await this.axios.get('/Region/xiaoqu/list', { projectId: this.projectId, daquId })
        this.xiaoquList = data.data?.data || data.data || data || []
      } catch (e) { console.error('加载小区失败', e) }
    },
    async searchDealers(query) {
      this.dealerLoading = true
      try {
        let res
        if (this.userRole === 'agent') {
          res = await this.axios.get('/WaveManager/wave/dealer/search-project', { projectId: parseInt(this.projectId), keyword: query || '' })
        } else {
          res = await this.axios.get('/Region/dealer/search', { keyword: query || '' })
        }
        this.dealerList = res?.data?.data?.data || res?.data?.data || res?.data || []
      } catch (e) { console.error('搜索经销商失败', e) }
      finally { this.dealerLoading = false }
    },
    onTypeChange(type) {
      this.form.dataType = type
      this.form.daquId = null
      this.form.xiaoquId = null
      this.form.dealerId = []
      this.xiaoquList = []
      this.dealerList = []
      if (type === 4) this.searchDealers('')
    },
    onDaquChange(val) {
      this.form.xiaoquId = null
      this.form.dealerId = []
      this.dealerList = []
      if (val) this.loadXiaoqu(val)
    },
    // 🔧 Bug修复: 合并已有权限 + 新增权限后再发送，避免覆盖式清除
    async doSave() {
      const newPerms = []
      const f = this.form
      if (f.dataType === 1) {
        newPerms.push({ dataType: 1, mixedId: 0 })
      } else if (f.dataType === 2) {
        if (!f.daquId) return this.$message.warning('请选择大区')
        newPerms.push({ dataType: 2, mixedId: f.daquId })
      } else if (f.dataType === 3) {
        if (!f.xiaoquId) return this.$message.warning('请选择小区')
        newPerms.push({ dataType: 3, mixedId: f.xiaoquId })
      } else if (f.dataType === 4) {
        if (!f.dealerId || f.dealerId.length === 0) return this.$message.warning('请选择经销商')
        f.dealerId.forEach(id => newPerms.push({ dataType: 4, mixedId: id }))
      }

      // 合并已有权限 + 新增权限，去重
      const existingPerms = this.existingList.map(p => ({
        dataType: p.DataType || p.dataType,
        mixedId: p.MixedId || p.mixedId
      }))
      const merged = [...existingPerms, ...newPerms]
      const seen = new Set()
      const uniquePerms = merged.filter(p => {
        const key = `${p.dataType}:${p.mixedId}`
        if (seen.has(key)) return false
        seen.add(key)
        return true
      })

      this.saving = true
      try {
        await savePermissions({
          uid: this.user.uid || this.user.userId,
          projectId: parseInt(this.projectId),
          permissions: uniquePerms
        })
        this.$message.success('权限保存成功')
        this.close()
        this.$emit('saved')
      } catch (e) { this.$message.error(e?.data?.message || '保存失败') }
      finally { this.saving = false }
    },
    async removeOnePerm(perm) {
      try {
        await deletePermission({
          uid: this.user.uid || this.user.userId,
          dataType: perm.DataType || perm.dataType,
          mixedId: perm.MixedId || perm.mixedId
        })
        this.existingList = this.existingList.filter(p =>
          !((p.DataType || p.dataType) === (perm.DataType || perm.dataType) &&
            (p.MixedId || p.mixedId) === (perm.MixedId || perm.mixedId))
        )
        this.$message.success('已移除')
      } catch (e) { this.$message.error('移除失败') }
    }
  }
}
</script>
